<div class="clone-user txt-button" *ngIf="isAddUser" (click)="cloneUser()" l10nTranslate>
  shared.copyUserRoleExistingUser
</div>
<div class="permission-text flex-grid">
  <div class="col">
    <h4 class="section-hdr flt-left" l10nTranslate>shared.locationPermissions</h4>
  </div>

  <div class="col">
    <div class="add-location txt-button" (click)="openDialog()">
      <span class="flt-right" l10nTranslate>shared.addLocation</span>
      <mat-icon class="flt-right" svgIcon="add-icon"></mat-icon>
    </div>
  </div>
</div>

<table
  aria-hidden="true"
  cdk-table
  [dataSource]="locationPermissionsDataSource"
  class="responsive permission-table location-permissions-table"
>
  <ng-container cdkColumnDef="globalRegion">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.globalRegion</th>
    <td cdk-cell *cdkCellDef="let row"><span *ngIf="row.globalRegionVal && row"></span> {{ row.globalRegionVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="division">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.division</th>
    <td cdk-cell *cdkCellDef="let row"><span *ngIf="row.divisionVal && row"></span> {{ row.divisionVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="market">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.market</th>
    <td cdk-cell *cdkCellDef="let row">
      {{ row.marketVal }}
    </td>
  </ng-container>

  <ng-container cdkColumnDef="submarket">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.submarket</th>
    <td cdk-cell *cdkCellDef="let row">
      {{ row.subMarketVal }}
      <span *ngIf="row.districtVal"> - {{ row.districtVal }}</span>
      <span *ngIf="row.neighborhoodVal"> - {{ row.neighborhoodVal }}</span>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="productType">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.productType</th>
    <td cdk-cell *cdkCellDef="let row">{{ row.propertyUsageTypeVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="businessJustification">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.businessJustification</th>
    <td cdk-cell *cdkCellDef="let row">
      <span>
        <mat-icon class="table-icons" matTooltip="{{ row.businessJustification }}">receipt</mat-icon>
      </span>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="confidentiality" class="confidentiality-label">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>
      shared.confidentiality
      <img
        [matTooltip]="'shared.confidentialityLevel' | xTranslate"
        [alt]="'shared.confidentialityLevel' | xTranslate"
        matTooltipClass="tooltip"
        class="confi-icon"
        src="assets/svg/mapinfo-icon.svg"
      />
    </th>
    <td cdk-cell *cdkCellDef="let row">{{ row.confidentialityTypeVal }}</td>
  </ng-container>

  <ng-container cdkColumnDef="Approve/Reject" *ngIf="pageType !== 'user'">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef l10nTranslate>shared.approveReject</th>
    <td cdk-cell *cdkCellDef="let row" class="locationper-radio">
      <mat-radio-group [(ngModel)]="row.accessRequestStatusId">
        <mat-radio-button [value]="1" l10nTranslate>shared.approveLocation</mat-radio-button>
        <mat-radio-button [value]="2" l10nTranslate>shared.rejectLocation</mat-radio-button>
      </mat-radio-group>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="buttons">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let row">
      <button *ngIf="pageType !== 'user' || requestMode" mat-icon-button (click)="edit(row)">
        <mat-icon class="table-icons">edit</mat-icon>
      </button>

      <button
        mat-icon-button
        *ngIf="(row.accessRequestStatusId !== 3 || requestMode) && !isPendingUser"
        (click)="deletePermission(row.userId, row.id, row.rowId)"
      >
        <mat-icon svgIcon="del-icon" class="table-icons-del"></mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="status">
    <th scope="col" cdk-header-cell *cdkHeaderCellDef></th>
    <td cdk-cell *cdkCellDef="let row">
      <span
        class="pending-approval"
        *ngIf="row.accessRequestStatusId && row.accessRequestStatusId === 3 && !requestMode && pageType !== 'Admin'"
        l10nTranslate
      >
        shared.pendingRequestApproval
        <mat-icon>report_problem</mat-icon>
      </span>
    </td>
  </ng-container>

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
</table>

<div class="no-records-message" *ngIf="locationPermissions?.length === 0" l10nTranslate>shared.noPermissionsFound</div>
